<div class="post-container">    
    <div class="navigation-content">
        <h4 routerLink="/categories"><< powrót do kategorii</h4>
    </div>    
</div>

<div class="post-container">    
    <div class="post-title post-title-blue">
        <h2>Domusie, gradła, papierniki, <br />czyli sprzęty i miejsca w domu</h2>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content">
        <p class="dfont center">
            Przywołaj miejsca w swoim domu lub jego otoczeniu, które uważasz za wyjątkowe, ważne, bliskie, w których 
            czujesz się najlepiej. Gdzie one są? Jak wyglądają? Co się w nich znajduje? Jak i z kim spędzasz tu czas?
        </p>
    </div>    

    <div class="post-content page-image">
        <img src="../../assets/game02/kotek.png" />
    </div>
</div>

<div class="post-container">
    <div class="post-content">
        <div class="examples">
            <div class="example">
                <img src="../../assets/game02/garderoba.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/skarbiec.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/basen.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/poduszka.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/lozko.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/krzeslo.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/prysznic.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/wazon.png" />
            </div>     
            <div class="example">
                <img src="../../assets/game02/przescieradlo.png" />
            </div>
            <div class="example">
                <img src="../../assets/game02/taboret.png" />
            </div>         
        </div>
        <div class="inputs">
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>
            <div class="input-box">
                <input type="text" placeholder="Pole do wpisania" />
            </div>            
        </div>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content">
        <p class="dfont center">
            A teraz uruchom wyobraźnię i zastanów się nad potrzebami swoimi i domowników. Wymyśl, jakie nieistniejące sprzęty 
            albo miejsca przydałyby się w waszym domu? Może połączenie wanny i wodoodpornej biblioteczki? Albo roweru i stołu? 
            Wyobraź je sobie, a następnie wymyśl ich nazwy i wpisz w puste pola.
        </p>
        <p class="dfont center">
            Wpisz swoje określenia na rysunku domu i prześlij poznane słówka.
        </p>
    </div> 
</div>

<div class="post-container">
    <div class="domek-content">
        <img src="../../assets/game02/domek.png" />
        <input type="text" class="pole-1" placeholder="pole do wpisania" />
        <input type="text" class="pole-2" placeholder="pole do wpisania" />
        <input type="text" class="pole-3" placeholder="pole do wpisania" />
        <input type="text" class="pole-4" placeholder="pole do wpisania" />
        <input type="text" class="pole-5" placeholder="pole do wpisania" />
        <input type="text" class="pole-6" placeholder="pole do wpisania" />
        <input type="text" class="pole-7" placeholder="pole do wpisania" />
        <input type="text" class="pole-8" placeholder="pole do wpisania" />
        <input type="text" class="pole-9" placeholder="pole do wpisania" />
    </div>
</div>    

<div class="post-container">
    <div class="post-content" style="text-align: right; margin-top: 50px;">
        <button class="dark"
            [routerLink]="['/task', taskId]">
            Przejdź dalej >>
        </button>
    </div>        
</div>
